export default __webpack_public_path__ + "static/media/gift.2273620b.png";